import Attribute from "vueforms/src/xmlrdb-metadata/Attribute";


Attribute.ValidatorFunctionRegistry["mustBeSetIfCheckboxSetWV"] = (attr) => {
  const wvDatum = attr.value;
  if (attr.dataElement.$.BONUS_WASSERVERSORGUNG_JN && (!wvDatum || wvDatum.length < 2)) {
    return "Datum muss gesetzt werden";
  }
}

Attribute.ValidatorFunctionRegistry["mustBeSetIfCheckboxSetABW"] = (attr) => {
  const abwDatum = attr.value;
  if (attr.dataElement.$.BONUS_ABWASSER_JN && (!abwDatum || abwDatum.length < 2)) {
    return "Datum muss gesetzt werden";
  }
}

/**
 * 
 * @param {import("vueforms/src/xmlrdb-data/Attribute").default} attr 
 */
 Attribute.ValidatorFunctionRegistry["TSM_DATE_VALIDATOR"] = (attr) => {
  const name = attr.metadata.name();
  const res = /TSM_\w{2,3}_/.exec(name);
  const checkBoxAttrName = res[0] + "JN";
  const checkBoxAttr = attr.dataElement.$$[checkBoxAttrName];
  if (!checkBoxAttr) {
    console.error("Attribut", name ,"CheckboxAttribut nicht gefunden", checkBoxAttrName, );
    return "FEHLER siehe Entwicklerkonsole";
  }
  if(checkBoxAttr.value && attr.value === null)
  return "Datum muss gesetzt werden";
}